<template>
  <v-card class="mx-auto mt-1 main-card" max-width="100vw" outlined>
    <v-row
      class="mx-0 mt-0 white--text"
      style="background-color:#881300;font-size:22px;height: 200px"
    >
      <v-col cols="7">
        <v-row class="mt-0">
          <v-col class="pl-10 display-1 text-center mt-6"
            >สถานการณ์อุบัติเหตุบนโครงข่ายของกระทรวงคมนาคม</v-col
          >
        </v-row>
        <v-row class="justify-center align-center"
          ><!-- remove mt-4 when compare-->
          <v-col cols="1"></v-col
          ><!-- cols="3" when compare-->
          <v-col cols="4">
            <DatePicker
              v-model="startDate"
              :max="today"
              @input="changeDate(utils.startDateChanged(startDate, endDate))"
              :defaultDate="startDate"
              ref="startDate"
              :redMode="true"
              :hideclearbtn="true"
            />
          </v-col>
          <v-col cols="1" class="text-center">ถึง</v-col>
          <v-col cols="4">
            <DatePicker
              v-model="endDate"
              :max="today"
              @input="changeDate(utils.endDateChanged(startDate, endDate))"
              :defaultDate="endDate"
              ref="endDate"
              :redMode="true"
              :hideclearbtn="true"
            />
          </v-col>
          <v-col cols="2">
            <v-btn
              color="white"
              @click="
                getOverAll();
                getTopaccidentProvince();
              "
              >ตกลง</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3" class="d-flex align-center justify-center">
        <span style="font-size:84px">TRAMS</span>
      </v-col>
      <v-col
        cols="2"
        class="py-0"
        style="background-color:#881300;position:absolute;top:0px;right:16px;border-radius:0px 0px 20px 20px;width:auto"
      >
        <v-row class="mt-0">
          <v-col
            class="d-flex align-center justify-center"
            style="background-color:#E2D8CE;border-radius:0px 0px 20px 20px;height:220px;"
          >
            <v-img
              max-width="188"
              max-height="188"
              :src="require(`@/assets/sumdashboard/All/weblogo.png`)"
            ></v-img>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="text-center mx-0" style="background-color:#D1B9A1">
      <v-col class="display-1">สรุปสถานการณ์อุบัติเหตุ</v-col>
    </v-row>
    <v-row class="mx-0 white--text d-flex" style="background-color:#46352D;">
      <v-col cols="4" style="border:1px solid #ffffff" class="py-8 align-center d-flex">
        <v-row class="pl-5 py-0">
          <v-col cols="3" class="d-flex align-center justify-center">
            <v-img
              max-width="84"
              max-height="84"
              :src="require(`@/assets/sumdashboard/All/transportation_white.svg`)"
            ></v-img>
          </v-col>
          <v-col cols="8" class="text-center">
            <v-col class="headline text-wrap" style="white-space: nowrap;"
              >ยานพาหนะที่เกิดเหตุสูงสุด</v-col
            >
            <v-divider :dark="true"></v-divider>
            <v-col class="headline text-wrap font-weight-medium">
              {{ summaryAccident.mostvehicle }}
              <v-tooltip
                v-if="summaryAccident.othervehicle"
                right
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="white"
                    dark
                    class="ml-1"
                    v-bind="attrs"
                    v-on="on"
                    >fa-info-circle</v-icon
                  >
                </template>
                <span v-html="summaryAccident.othervehicle"></span>
              </v-tooltip>
            </v-col>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="4"
        class="py-0 align-center d-flex"
        style="white-space: nowrap;border: 1px solid #ffffff"
      >
        <v-row class="pl-5 py-0">
          <v-col cols="3" class="d-flex align-center justify-center">
            <v-img
              max-width="80"
              max-height="80"
              :src="require(`@/assets/sumdashboard/All/dead.png`)"
            ></v-img>
          </v-col>
          <v-col cols="8" class="text-center">
            <v-col class="headline text-wrap">จังหวัดที่มีผู้เสียชีวิตสูงสุด</v-col>
            <v-divider :dark="true"></v-divider>
            <v-col class="headline text-wrap font-weight-medium">
              {{ summaryAccident.mostprovince }}
              <v-tooltip
                v-if="summaryAccident.otherprovince"
                right
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="white"
                    dark
                    class="ml-1"
                    v-bind="attrs"
                    v-on="on"
                    >fa-info-circle</v-icon
                  >
                </template>
                <span v-html="summaryAccident.otherprovince"></span>
              </v-tooltip>
            </v-col>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="4" class="py-0 align-center d-flex" style="border: 1px solid #ffffff">
        <v-row class="pl-5 py-0">
          <v-col cols="12" class="text-center pr-5">
            <v-row>
              <v-col cols="8" class="headline">
                อัตราการเสียชีวิตต่อประชากร
                <span class="text-no-wrap">1 แสนคน</span>
              </v-col>
              <v-col cols="1" class="d-flex headline align-center justify-center mb-1">:</v-col>
              <v-col cols="3" class="d-flex align-center justify-center headline font-weight-medium"
                >{{ calculateDeathperpopulation }} คน</v-col
              >
            </v-row>
            <v-divider class="my-2" :dark="true"></v-divider>
            <v-row>
              <v-col cols="8" class="headline">
                อัตราการเสียชีวิตต่อรถจดทะเบียน
                <span class="text-no-wrap">1 แสนคัน</span>
              </v-col>
              <v-col cols="1" class="d-flex headline align-center justify-center mb-1">:</v-col>
              <v-col cols="3" class="d-flex align-center justify-center headline font-weight-medium"
                >{{ calculateDeathpervehicle }} คน</v-col
              >
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="text-center mx-0" style="background-color:#D1B9A1">
      <v-col class="display-1">ภาพรวมสถานการณ์อุบัติเหตุ</v-col>
    </v-row>
    <v-row class="mx-0 mb-0" style="font-size:18px;">
      <v-col
        cols="6"
        :class="'mx-0 pa-0'"
        v-for="(item, i) in overAllaccident"
        :key="i"
        :style="item.subbgcolor ? 'background-color:' + item.subbgcolor : ''"
        @click="gotoExecutive(i)"
      >
        <v-hover v-slot:default="{ hover }">
          <v-row
            class="mx-0 px-3 py-1 my-0 accident-bg cursor"
            :style="'height:100%;background-color:' + item.bgcolor"
          >
            <!-- logo -->
            <v-card
              class="d-flex justify-center align-center my-1 mr-4 icon-bg"
              style="background-color:#E0D8CF;border-radius:50%;"
              :elevation="hover ? 16 : 0"
            >
              <v-img v-if="item.type == 'img'" class="icon" :src="item.img"></v-img>
              <i v-else :class="`${item.img} fa-3x`"></i>
            </v-card>
            <div v-resize="onResize" class="casualty" :style="'background-color:' + item.bgcolor">
              <v-row class="text-center">
                <v-col class="accident-box">
                  <v-col class="head-font one-line py-2">อุบัติเหตุ</v-col>
                  <v-divider></v-divider>
                  <v-col class="pt-1 pb-2">
                    <span class="number-font">{{ utils.formatNumber(item.accident) }}</span>
                    <br /><span class="suffix-font">ครั้ง</span>
                  </v-col>
                </v-col>
                <v-col class="accident-box">
                  <v-col class="head-font one-line py-2">ผู้เสียชีวิต</v-col>
                  <v-divider></v-divider>
                  <v-col class="pt-1 pb-2">
                    <span class="number-font">{{ utils.formatNumber(item.death) }}</span>
                    <br /><span class="suffix-font">คน</span>
                  </v-col>
                </v-col>
                <v-col class="accident-box">
                  <v-col class="head-font one-line py-2">ผู้บาดเจ็บ</v-col>
                  <v-divider></v-divider>
                  <v-col class="pt-1 pb-2">
                    <span class="number-font">{{ utils.formatNumber(item.injure) }}</span>
                    <br /><span class="suffix-font">คน</span>
                  </v-col>
                </v-col>
              </v-row>
            </div>
          </v-row>
        </v-hover>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
// eslint-disable-next-line import/extensions
import DatePicker from '../global/DatePicker';

export default {
  name: 'ExecutiveOverviewReport',
  components: {
    DatePicker
  },
  data: () => ({
    today: null,
    startDate: null,
    endDate: null,
    summaryAccident: {
      mostvehicle: 'ไม่มีข้อมูล',
      mostprovince: 'ไม่มีข้อมูล',
      othervehicle: null,
      otherprovince: null,
      deathperperson: 0,
      deathpervehicle: 0
    },
    overAllaccident: [
      {
        img: require('@/assets/sumdashboard/All/car.png'),
        type: 'img',
        accident: 0,
        death: 0,
        injure: 0,
        bgcolor: '#F37219'
      },
      {
        img: require('@/assets/sumdashboard/All/train.png'),
        type: 'img',
        accident: 0,
        death: 0,
        injure: 0,
        bgcolor: '#6FCEB3',
        subbgcolor: '#F37219'
      },
      {
        type: 'img',
        img: require('@/assets/sumdashboard/All/ship.png'),
        accident: 0,
        death: 0,
        injure: 0,
        bgcolor: '#83C4D8'
      },
      {
        type: 'img',
        img: require('@/assets/sumdashboard/All/airplane.png'),
        accident: 0,
        death: 0,
        injure: 0,
        bgcolor: '#7972D1',
        subbgcolor: '#83C4D8'
      }
    ],
    thailandPop: 66558935
  }),
  created() {},
  mounted() {
    const date = this.utils.getLocalDate();
    this.today = date;
    this.startDate = date;
    this.endDate = date;
    this.getDefaultFestival();
  },
  methods: {
    getDefaultFestival() {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/festival/default`;
      this.axios.get(url).then(response => {
        const res = response.data.data;
        const defaultfes = res.filter(member => {
          return member.isdefault;
        })[0];
        this.startDate = defaultfes.start_date.split(' ')[0];
        this.endDate = defaultfes.end_date.split(' ')[0];
        this.getTopaccidentProvince();
        this.getOverAll();
      });
    },
    getTopaccidentProvince() {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/executive/all`;
      this.axios
        .get(url, {
          params: {
            start_date: this.startDate,
            end_date: this.endDate
          }
        })
        .then(response => {
          const res = response.data.data;
          if (Array.isArray(res.province) && res.province.length) {
            if (res.province.length == 1) {
              this.summaryAccident.mostprovince = res.province[0];
              this.summaryAccident.otherprovince = null;
            }
            else {
              this.summaryAccident.mostprovince = res.province[0] + ' และอื่นๆ';
              this.summaryAccident.otherprovince = res.province.slice(1).join('</br>');
            }
          }
          else {
            this.summaryAccident.mostprovince = 'ไม่มีข้อมูล';
            this.summaryAccident.otherprovince = null;
          }
          if (Array.isArray(res.vehicle) && res.vehicle.length) {
            if (res.vehicle.length == 1) {
              this.summaryAccident.mostvehicle = res.vehicle[0];
              this.summaryAccident.othervehicle = null;
            }
            else {
              this.summaryAccident.mostvehicle = res.vehicle[0] + ' และอื่นๆ';
              this.summaryAccident.othervehicle = res.vehicle.slice(1).join('</br>');
            }
          }
          else {
            this.summaryAccident.mostvehicle = 'ไม่มีข้อมูล';
            this.summaryAccident.othervehicle = null;
          }
          this.summaryAccident.deathpervehicle = res.dead > 0 ? (res.dead / 400).toFixed(2) : 0;
          if (res.population) {
            this.thailandPop = res.population;
          }
        });
    },
    // numformat(value) {
    //   if (value < 10 && value !== 0) return `0${value}`;
    //   return value;
    // },
    getOverAll() {
      const type = ['road', 'rail', 'water', 'air'];
      localStorage.setItem('execParams', JSON.stringify({
        'startDate': this.startDate,
        'endDate': this.endDate
      }));
      for (let index = 0; index < type.length; index += 1) {
        const element = type[index];
        const url = `${process.env.VUE_APP_SERVICE_API_URL}/main/dashboard/summary/${element}`;
        this.axios
          .get(url, {
            params: {
              start_date: this.startDate,
              end_date: this.endDate,
              report_date:this.utils.getLocalDate(),
            }
          })
          // eslint-disable-next-line no-loop-func
          .then(response => {
            const res = response.data.data;
            const paneldata = this.overAllaccident[index];
            paneldata.accident = res.accident.summary;
            paneldata.death = res.dead.summary;
            paneldata.injure = res.injury.summary;
          });
      }
    },
    onResize() {
      const el = document.getElementsByClassName('casualty');
      for (let index = 0; index < el.length; index++) {
        el[index].style.width = `${Math.max(window.innerWidth / 2 - 300, 300)}px`;
      }
    },
    gotoExecutive(idx) {
      switch (idx) {
        case 0:
          this.$router.push({ name: 'road-executive' });
          break;
        case 1:
          this.$router.push({ name: 'rail-executive' });
          break;
        case 2:
          this.$router.push({ name: 'water-executive' });
          break;
        case 3:
          this.$router.push({ name: 'air-executive' });
          break;
        default:
          break;
      }
    },
    changeDate(period) {
      if (period) {
        if (period.startDate != this.startDate) {
          this.$refs.startDate.setDefaultData(period.startDate);
        }
        if (period.endDate != this.endDate) {
          this.$refs.endDate.setDefaultData(period.endDate);
        }
      }
    }
  },
  watch: {
    // startDate() {
    //   this.getOverAll();
    //   this.getTopaccidentProvince();
    // },
    // endDate() {
    //   this.getOverAll();
    //   this.getTopaccidentProvince();
    // }
  },
  computed: {
    calculateDeathperpopulation() {
      let sum = 0;
      for (let index = 0; index < this.overAllaccident.length; index++) {
        const element = this.overAllaccident[index];
        sum += parseInt(element.death, 10);
      }
      return ((sum * 100000) / this.thailandPop).toFixed(2);
    },
    calculateDeathpervehicle() {
      let sum = 0;
      for (let index = 0; index < this.overAllaccident.length; index++) {
        const element = this.overAllaccident[index];
        sum += parseInt(element.death, 10);
      }
      return (sum / 400).toFixed(2);
    }
  }
};
</script>

<style lang="scss" scoped>
.main-card {
  min-width: 1200px;
}

.one-line {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.head-font {
  font-size: 18px;
}

.number-font {
  font-size: 30px;
}

.suffix-font {
  font-size: 14px;
}

.icon-bg {
  width: 143px;
  height: 143px;
}

.icon {
  max-width: 84px;
  max-height: 84px;
}

.accident-bg {
  border-radius: 100px 0px 0px 100px;
}
@media only screen and (max-width: 1120px) {
  .head-font {
    font-size: 16px;
  }

  .number-font {
    font-size: 24px;
  }

  .suffix-font {
    font-size: 12px;
  }
  .icon-bg {
    width: 115px;
    height: 115px;
  }
  .icon {
    max-width: 42px;
    max-height: 42px;
  }
  .accident-box {
    padding-top: 4px;
    padding-bottom: 4px;
  }
  .accident-bg {
    border-radius: 70px 0px 0px 70px;
  }
}
</style>
